import { render, staticRenderFns } from "./TriviaEX.vue?vue&type=template&id=27a44697&scoped=true&"
import script from "./TriviaEX.vue?vue&type=script&lang=js&"
export * from "./TriviaEX.vue?vue&type=script&lang=js&"
import style0 from "./TriviaEX.vue?vue&type=style&index=0&id=27a44697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a44697",
  null
  
)

export default component.exports